import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IdeaModel from 'scaleflow/models/idea';
import IdeaValidations from 'scaleflow/validators/idea';

export interface IdeasIdeaSelectorSignature {
  // The arguments accepted by the component
  Args: {
    idea: IdeaModel;
    propagateIdeaSelect?: (idea: IdeaModel) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}

export default class IdeasIdeaSelectorComponent extends Component<IdeasIdeaSelectorSignature> {
  @service declare store: any;
  @tracked showDropdown = false;
  ideaValidations = IdeaValidations;

  @action isSelected(idea: IdeaModel): boolean {
    return this.idea.id == idea.id;
  }

  @action
  toggleDropdown(val?: boolean): void {
    if (val === undefined) this.showDropdown = !this.showDropdown;
    else this.showDropdown = val;
  }

  @action
  handleIdeaSelect(idea: IdeaModel): void {
    this.toggleDropdown(false);
    this.args?.propagateIdeaSelect?.(idea);
  }

  get idea(): IdeaModel {
    return this.args.idea;
  }

  get ideas() {
    return this.store.peekAll('idea');
  }
}
